import axios from 'axios';

export const getOriginalPrice = async (format: string, quantity?: number) => {
  return axios
    .get(`/products/price/${format}${quantity ? '/' + quantity : ''}`)
    .then((response) => response)
    .catch((error) => ({ data: 0 }));
};
